import { twMerge } from "tailwind-merge";
import {
  BuyerProductGetResponseChildType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { Badge } from "../../../../components/badge/Badge";
import { Card } from "@sellar-io/components";
import { SelectedFulfillmentTypeCard } from "../../../../components/fulfillmentTypeCards/SelectedFulfillmentTypeCard";
import { getFulfillmentType } from "../../../../components/map/SellarMap.shared";
import { useSupplier } from "../../../../hooks/api/v2/supplier/useSupplier";
import { useDiscoveryV2SearchStore } from "../DiscoveryV2SearchStore";
import { SelectedFulfillmentTypeCardLegacy } from "~/components/fulfillmentTypeCards/SelectedFulfillmentTypeCardLegacy";

export const DiscoveryDialogFulfillmentTypeInformation = ({
  supplierId,
  supplierStorefront,
  productItem,
  isDeliveredBySellar,
}: {
  isDeliveredBySellar?: boolean;
  supplierId: number;
  supplierStorefront: SupplierStorefrontV2GetResponseType;
  productItem?: Pick<
    BuyerProductGetResponseChildType,
    "containerType" | "unit" | "volume"
  >;
}) => {
  const marketIsDeliveredBySellar = useDiscoveryV2SearchStore(
    (state) => state.isDeliveredBySellar,
  );

  const selectedFulfillmentType = computeSelectedFulfillmentType({
    supplierStorefront,
    isDeliveredBySellar: isDeliveredBySellar ?? marketIsDeliveredBySellar,
  });
  const supplierQuery = useSupplier(supplierId);
  const fulfillmentType =
    selectedFulfillmentType === "collection"
      ? "direct"
      : selectedFulfillmentType === "sellarDistribution"
        ? "courier"
        : selectedFulfillmentType;

  const unbundlingEnabled =
    supplierStorefront.deliveryMethods &&
    supplierStorefront.deliveryMethods.length > 0;

  return (
    <>
      {supplierQuery.data && (
        <Card
          className={twMerge(
            "bg-white",
            "flex flex-col gap-2 border border-solid p-4",
          )}
        >
          <Badge icon={"TRUCK"}>Delivery options</Badge>
          {unbundlingEnabled ? (
            <SelectedFulfillmentTypeCard
              supplier={supplierQuery.data}
              selectedFulfillmentType={selectedFulfillmentType}
              supplierStorefront={supplierStorefront}
              productItem={productItem}
            />
          ) : (
            <SelectedFulfillmentTypeCardLegacy
              supplier={supplierQuery.data}
              selectedFulfillmentType={selectedFulfillmentType}
              supplierStorefront={supplierStorefront}
              productItem={productItem}
              fulfillmentType={{
                ...supplierStorefront.FulfillmentType,
                fulfillmentType,
              }}
              connection={supplierStorefront.SupplierRetailerConnection}
            />
          )}
        </Card>
      )}
    </>
  );
};

const computeSelectedFulfillmentType = ({
  supplierStorefront,
  isDeliveredBySellar,
}: {
  supplierStorefront: SupplierStorefrontV2GetResponseType;
  isDeliveredBySellar: boolean;
}): ReturnType<typeof getFulfillmentType> => {
  if (isDeliveredBySellar) {
    return "sellarDistribution";
  }

  const storefrontFulfillmentType =
    supplierStorefront.FulfillmentType.fulfillmentType;

  return getFulfillmentType(storefrontFulfillmentType);
};
